function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_207",
  "data-name": "Path 207",
  d: "M175.17,60.543a5.541,5.541,0,0,1-1.383-3.667,5.613,5.613,0,0,1,11.225,0,5.548,5.548,0,0,1-1.377,3.662c.371.131.733.278,1.089.44a6.636,6.636,0,0,0,1.414-4.1,6.739,6.739,0,0,0-13.478,0,6.647,6.647,0,0,0,1.42,4.113,11.389,11.389,0,0,1,1.089-.446",
  transform: "translate(-158.283 -50.15)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_260",
  "data-name": "Rectangle 260",
  width: 14.75,
  height: 11.986,
  transform: "translate(13.86)",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_229",
  "data-name": "Path 229",
  d: "M158.946,109.268h31.325a.558.558,0,0,1-.388-.964c.016-.016.068-.068.152-.158h-21.1c.078.09.137.142.152.158a.558.558,0,0,1-.387.964.572.572,0,0,1-.387-.152,7.347,7.347,0,0,1-.828-.97h-7.868l1.839-10.329a13.273,13.273,0,0,1,9.6-10.477l7.978,10.508a.563.563,0,0,0,.451.225h.005a.582.582,0,0,0,.451-.23l7.737-10.566a13.237,13.237,0,0,1,9.837,10.54l1.833,10.329h-7.868a6.569,6.569,0,0,1-.828.97.539.539,0,0,1-.382.152h9.754a.576.576,0,0,0,.429-.2.553.553,0,0,0,.121-.456l-1.954-10.99A14.344,14.344,0,0,0,187.568,86.1a.561.561,0,0,0-.576.214l-7.517,10.257-7.747-10.2a.565.565,0,0,0-.581-.209,14.4,14.4,0,0,0-10.8,11.462l-1.954,10.99a.563.563,0,0,0,.555.655",
  transform: "translate(-158.365 -49.944)",
  fill: "#707070"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_262",
  "data-name": "Rectangle 262",
  width: 42.241,
  height: 23.216,
  transform: "translate(0 36.124)",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_230",
  "data-name": "Path 230",
  d: "M191.3,108.081a12.188,12.188,0,0,0,1.907-10.063.563.563,0,0,0-.671-.424.554.554,0,0,0-.429.665,10.849,10.849,0,0,1-2.252,9.822c-.084.09-.137.142-.153.157a.559.559,0,0,0,.388.965.539.539,0,0,0,.382-.152,6.571,6.571,0,0,0,.828-.97",
  transform: "translate(-158.186 -49.878)",
  fill: "#707070"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_263",
  "data-name": "Rectangle 263",
  width: 5.364,
  height: 12.487,
  transform: "translate(31.293 46.853)",
  fill: "none"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_231",
  "data-name": "Path 231",
  d: "M166.643,98.259a.563.563,0,0,0-1.1-.241,12.212,12.212,0,0,0,1.9,10.064,7.3,7.3,0,0,0,.828.969.573.573,0,0,0,.387.152.558.558,0,0,0,.388-.964c-.016-.016-.073-.068-.152-.157a10.839,10.839,0,0,1-2.253-9.822",
  transform: "translate(-158.325 -49.877)",
  fill: "#707070"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_264",
  "data-name": "Rectangle 264",
  width: 5.364,
  height: 12.487,
  transform: "translate(5.814 46.853)",
  fill: "none"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_208",
  "data-name": "Path 208",
  d: "M165.4,77.764a2.5,2.5,0,0,0,1.525.565,2.016,2.016,0,0,0,.581-.083,2.083,2.083,0,0,0,.686-.351c-.178-.351-.34-.717-.487-1.084a1.022,1.022,0,0,1-.514.361,1.238,1.238,0,0,1-1.1-.293,2.842,2.842,0,0,1-.926-1.446,2.769,2.769,0,0,1,.005-1.713,1.235,1.235,0,0,1,.769-.833.908.908,0,0,1,.262-.036,1.268,1.268,0,0,1,.671.214c-.011-.162-.021-.325-.027-.492v-.336c0-.136.006-.273.011-.408a2.148,2.148,0,0,0-1.231-.016,2.3,2.3,0,0,0-1.514,1.53,3.872,3.872,0,0,0-.026,2.4,3.939,3.939,0,0,0,1.315,2.017",
  transform: "translate(-158.333 -50.025)",
  fill: "#707070"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_209",
  "data-name": "Path 209",
  d: "M191.555,77.166a1.007,1.007,0,0,0,.4.026,18.752,18.752,0,0,0-.325-2.048.563.563,0,0,1,1.1-.241c.041.194.173.812.278,1.624a3.064,3.064,0,0,0,.576-1.1,2.8,2.8,0,0,0-.006-1.713,1.239,1.239,0,0,0-.774-.833.886.886,0,0,0-.263-.037,1.277,1.277,0,0,0-.671.215,12.2,12.2,0,0,1-.838,3.739,1.053,1.053,0,0,0,.524.367",
  transform: "translate(-158.177 -50.02)",
  fill: "#707070"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_210",
  "data-name": "Path 210",
  d: "M191.891,71.912c.005.1.005.215.005.325,0,.278-.01.55-.031.828a1.275,1.275,0,0,1,.671-.215.88.88,0,0,1,.262.037,1.238,1.238,0,0,1,.775.833,2.807,2.807,0,0,1,.005,1.713,3.064,3.064,0,0,1-.576,1.1c.052.418.1.89.131,1.378.068-.047.142-.095.21-.147a4.147,4.147,0,0,0,1.288-4.421,2.321,2.321,0,0,0-1.519-1.53,2.122,2.122,0,0,0-1.226.016.437.437,0,0,1,.005.083",
  transform: "translate(-158.172 -50.026)",
  fill: "#707070"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_211",
  "data-name": "Path 211",
  d: "M191.558,77.143a1.053,1.053,0,0,1-.524-.367,11.078,11.078,0,0,1-.487,1.085,2.045,2.045,0,0,0,.7.356,1.971,1.971,0,0,0,.575.083c.073,0,.142-.005.21-.01-.011-.367-.037-.744-.073-1.121a1.007,1.007,0,0,1-.4-.026",
  transform: "translate(-158.18 -49.997)",
  fill: "#707070"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_212",
  "data-name": "Path 212",
  d: "M189.481,73.016a3.968,3.968,0,0,1-2.173-.98,3.968,3.968,0,0,0,2.173.98",
  transform: "translate(-158.198 -50.024)",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_213",
  "data-name": "Path 213",
  d: "M170.454,72.573c-.062.068-.131.131-.194.188.063-.057.132-.12.194-.188",
  transform: "translate(-158.296 -50.021)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_214",
  "data-name": "Path 214",
  d: "M169.276,73.36a1.7,1.7,0,0,0,.23-.095,1.7,1.7,0,0,1-.23.095",
  transform: "translate(-158.302 -50.018)",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_215",
  "data-name": "Path 215",
  d: "M169.536,73.252a2.839,2.839,0,0,0,.456-.268,2.839,2.839,0,0,1-.456.268",
  transform: "translate(-158.301 -50.019)",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_216",
  "data-name": "Path 216",
  d: "M189.876,73.016c-.036,0-.068.005-.1.005.031,0,.063-.005.1-.005",
  transform: "translate(-158.184 -50.02)",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_217",
  "data-name": "Path 217",
  d: "M190.083,73l.116-.016-.116.016",
  transform: "translate(-158.182 -50.019)",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_218",
  "data-name": "Path 218",
  d: "M169,73.443c.083-.021.162-.047.241-.073-.079.026-.158.052-.241.073",
  transform: "translate(-158.304 -50.017)",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_219",
  "data-name": "Path 219",
  d: "M170.021,72.959c.073-.052.136-.11.2-.168-.068.058-.131.116-.2.168",
  transform: "translate(-158.298 -50.02)",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_220",
  "data-name": "Path 220",
  d: "M184.848,82.311a11.49,11.49,0,0,1-16.825-8.853c.015.005.036.005.057.01a2.554,2.554,0,0,1-1.006-.456.563.563,0,0,1-.24-.446c.005.168.015.331.026.493a12.436,12.436,0,0,0,.833,3.745c.147.367.309.733.487,1.084a12.636,12.636,0,0,0,18.3,4.746c-.571-.1-1.126-.215-1.634-.325",
  transform: "translate(-158.316 -50.021)",
  fill: "#707070"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path_221",
  "data-name": "Path 221",
  d: "M168.76,73.484c.078-.01.157-.026.241-.042-.085.016-.163.032-.241.042",
  transform: "translate(-158.305 -50.016)",
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path_222",
  "data-name": "Path 222",
  d: "M168.073,73.463c.062.01.121.021.183.026-.062-.005-.121-.016-.183-.026",
  transform: "translate(-158.309 -50.016)",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Path_223",
  "data-name": "Path 223",
  d: "M168.725,73.49c-.078.005-.152.01-.23.01.078,0,.152-.005.23-.01",
  transform: "translate(-158.307 -50.017)",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Path_224",
  "data-name": "Path 224",
  d: "M168.307,73.5a1.235,1.235,0,0,0,.136.005,1.235,1.235,0,0,1-.136-.005",
  transform: "translate(-158.308 -50.017)",
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "Path_225",
  "data-name": "Path 225",
  d: "M190.391,72.948l.121-.026-.121.026",
  transform: "translate(-158.181 -50.02)",
  fill: "#fff"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "Path_226",
  "data-name": "Path 226",
  d: "M186.109,81.446c.5.095,1,.178,1.488.246a12.55,12.55,0,0,0,2.975-3.8,11.093,11.093,0,0,0,.488-1.085,12.225,12.225,0,0,0,.838-3.739c.021-.278.031-.55.031-.828,0-.111,0-.22-.005-.325a.552.552,0,0,1-.23.466,3.462,3.462,0,0,1-.975.493c.026-.005.047-.01.068-.016a11.411,11.411,0,0,1-4.678,8.591",
  transform: "translate(-158.205 -50.025)",
  fill: "#707070"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  id: "Path_227",
  "data-name": "Path 227",
  d: "M179.436,60.876A11.386,11.386,0,0,1,190.9,71.7a2.047,2.047,0,0,1-1.194.272,3.439,3.439,0,0,1-2.232-1.45,12.4,12.4,0,0,1-1.105-1.876c-.142-.273-.283-.555-.435-.833a3.687,3.687,0,0,0-.891-1.148,3.453,3.453,0,0,0-1.928-.623,17.916,17.916,0,0,0-2.373.02l-6.778.346a2.921,2.921,0,0,0-1.6.429,2.823,2.823,0,0,0-.854,1.252l-.927,2.153a5.821,5.821,0,0,1-.932,1.644,1.55,1.55,0,0,1-1.347.555,1.245,1.245,0,0,1-.345-.126v-.01a11.468,11.468,0,0,1,11.482-11.43m-12.6,11.765a.566.566,0,0,0,.241.446,2.57,2.57,0,0,0,1.006.456c.062.01.12.021.183.026a.181.181,0,0,0,.052.005,1.225,1.225,0,0,0,.136.005c.011,0,.021.005.032.005s.015-.005.02-.005c.079,0,.152-.005.231-.01a.09.09,0,0,1,.036-.005c.078-.011.157-.026.241-.042s.162-.047.24-.073a.368.368,0,0,0,.037-.01,1.846,1.846,0,0,0,.23-.095l.031-.016a2.909,2.909,0,0,0,.456-.267.122.122,0,0,1,.032-.026c.072-.052.136-.111.2-.168a.192.192,0,0,1,.036-.031c.063-.058.131-.121.194-.189a6.649,6.649,0,0,0,1.137-1.964l.927-2.153a1.915,1.915,0,0,1,.492-.785,1.851,1.851,0,0,1,.991-.214l6.778-.351a18.582,18.582,0,0,1,2.232-.021,2.459,2.459,0,0,1,1.315.382,2.656,2.656,0,0,1,.6.812c.147.263.289.54.424.807a13.534,13.534,0,0,0,1.2,2.039,5.992,5.992,0,0,0,.854.911,3.975,3.975,0,0,0,2.173.98c.106.005.205.01.31.01.031,0,.062-.005.1-.005l.209-.016.116-.015c.062-.011.131-.021.193-.037.042-.01.078-.015.121-.026.063-.021.121-.036.183-.057a3.489,3.489,0,0,0,.975-.493.552.552,0,0,0,.23-.466.448.448,0,0,0-.005-.084,12.423,12.423,0,0,0-3.788-8.569,12.578,12.578,0,0,0-3.483-2.4c-.356-.163-.718-.309-1.089-.441a12.617,12.617,0,0,0-8.465.006c-.372.131-.733.283-1.089.445A12.559,12.559,0,0,0,166.843,71.9c-.005.137-.01.273-.01.409v.335",
  transform: "translate(-158.316 -50.095)",
  fill: "#707070"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Path_228",
  "data-name": "Path 228",
  d: "M171.654,86.374l7.747,10.2-7.213-9.5a13.553,13.553,0,0,1,2.3-.2h9.852a13.535,13.535,0,0,1,2.059.157L179.4,96.578l7.517-10.257a.56.56,0,0,1,.576-.215,14.531,14.531,0,0,0-3.159-.351h-9.852a14.711,14.711,0,0,0-3.411.409.565.565,0,0,1,.581.209",
  transform: "translate(-158.292 -49.945)",
  fill: "#707070"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  id: "Path_232",
  "data-name": "Path 232",
  d: "M193.055,76.517c-.1-.812-.235-1.43-.278-1.624a.563.563,0,1,0-1.1.241A18.549,18.549,0,0,1,192,77.182c.037.377.063.754.073,1.121.047,1.6-.178,3.012-.911,3.326a8,8,0,0,1-3.546.047c-.493-.068-.991-.152-1.488-.246-1.31-.245-2.557-.555-3.348-.774l-.094.686a1.281,1.281,0,0,1-.132.408c.43.121,1.231.335,2.2.55.508.11,1.063.225,1.634.325a20.024,20.024,0,0,0,3.248.33,5.192,5.192,0,0,0,1.964-.3c1.461-.618,1.687-2.844,1.582-4.761-.031-.488-.078-.958-.131-1.378",
  transform: "translate(-158.226 -50.011)",
  fill: "#707070"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  id: "Path_233",
  "data-name": "Path 233",
  d: "M181.445,81.264a.122.122,0,0,0,.141-.1l.152-1.1a.117.117,0,0,0-.026-.095.106.106,0,0,0-.084-.047l-1.105-.152h-.015a.109.109,0,0,0-.078.026.115.115,0,0,0-.047.084l-.152,1.1a.131.131,0,0,0,.11.141Z",
  transform: "translate(-158.239 -49.979)",
  fill: "#707070"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  id: "Path_234",
  "data-name": "Path 234",
  d: "M180.235,80.981l.152-1.1a.122.122,0,0,1,.047-.084.112.112,0,0,1,.078-.026h.016l1.105.152a.1.1,0,0,1,.083.047.111.111,0,0,1,.026.095l-.152,1.1a.122.122,0,0,1-.141.1l-1.105-.147a.133.133,0,0,1-.111-.142m2.379-1.692a1.239,1.239,0,0,0-.828-.477l-1.105-.152a1.256,1.256,0,0,0-1.409,1.068l-.147,1.1a1.25,1.25,0,0,0,1.069,1.4l1.105.147a.993.993,0,0,0,.173.01,1.257,1.257,0,0,0,1.105-.665,1.313,1.313,0,0,0,.131-.408l.094-.687.058-.418a1.247,1.247,0,0,0-.246-.922",
  transform: "translate(-158.246 -49.986)",
  fill: "#707070"
});

function SvgReceptionist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_136_1",
    "data-name": "Component 136 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.241,
    height: 59.34,
    viewBox: "0 0 42.241 59.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptionist);
export default __webpack_public_path__ + "static/media/receptionist.960982b6eca8f12b0b69e7d2ab55a087.svg";
export { ForwardRef as ReactComponent };